import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import get from 'lodash/get'

/**
 * Returns the timezone if it exists
 * @param state The Redux state
 */

const getWebcastTimezone = (state: State): string => {

  const collectionId = `${state.config.channelId}${state.config.webcastId}`
  return get(state.webcast, `collection.${collectionId}.data.timeZone`, '')

}

export default createSelector<State, string, string>(
  [getWebcastTimezone],
  (timezone) => timezone
)
